import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Phone, FileText, X, CheckCircle2 } from "lucide-react";

// Sticky mobile call/quote bar — visible only on phones, sits below the chat FAB
export const StickyMobileCTA = () => {
  return (
    <div data-testid="sticky-mobile-cta" className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-blue-950/95 backdrop-blur-md border-t border-blue-900 flex">
      <a href="tel:+17866224963" data-testid="sticky-call-btn" className="flex-1 py-3.5 flex items-center justify-center gap-2 text-white font-bold text-sm border-r border-blue-900 active:bg-blue-900">
        <Phone size={16} /> Call Now
      </a>
      <a href="/#quote-section" data-testid="sticky-quote-btn" className="flex-1 py-3.5 flex items-center justify-center gap-2 bg-amber-600 text-white font-bold text-sm active:bg-amber-700">
        <FileText size={16} /> Free Quote
      </a>
    </div>
  );
};

// Exit-intent popup — fires once per session when the cursor leaves the top of the viewport
export const ExitIntentModal = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("exitIntentShown")) return;
    const handler = (e) => {
      if (e.clientY <= 0) {
        setOpen(true);
        sessionStorage.setItem("exitIntentShown", "1");
        document.removeEventListener("mouseout", handler);
      }
    };
    const timer = setTimeout(() => document.addEventListener("mouseout", handler), 4000);
    return () => {
      clearTimeout(timer);
      document.removeEventListener("mouseout", handler);
    };
  }, []);

  if (!open) return null;

  return (
    <div data-testid="exit-intent-modal" className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-slate-900/70 backdrop-blur-sm animate-fade-in" onClick={() => setOpen(false)}>
      <div className="relative bg-white rounded-2xl max-w-md w-full overflow-hidden shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <button data-testid="exit-intent-close" onClick={() => setOpen(false)} className="absolute top-3 right-3 p-1.5 rounded-full bg-white/80 hover:bg-gray-100 text-gray-500 z-10"><X size={18} /></button>
        <div className="bg-blue-950 px-7 py-6 text-center">
          <span className="text-amber-400 text-xs font-bold uppercase tracking-widest font-heading">Wait — Before You Go</span>
          <h3 className="text-2xl font-heading text-white mt-2">Get Your Free Septic Quote</h3>
        </div>
        <div className="p-7 space-y-4 text-center">
          <p className="text-sm text-gray-600">Get an instant cost range with our online estimator — no obligation, no phone call required.</p>
          <ul className="text-left space-y-2 text-sm text-gray-600 max-w-xs mx-auto">
            {["Free, instant cost estimate", "Licensed & insured (#CFC1432999)", "Serving Miami-Dade & Broward"].map((t) => (
              <li key={t} className="flex items-center gap-2"><CheckCircle2 size={16} className="text-emerald-500" /> {t}</li>
            ))}
          </ul>
          <div className="flex flex-col gap-2 pt-2">
            <a href="/#calculator" onClick={() => setOpen(false)} data-testid="exit-intent-estimate" className="w-full py-3 rounded-xl bg-amber-600 hover:bg-amber-700 text-white font-bold transition">Get My Free Estimate</a>
            <a href="tel:+17866224963" className="w-full py-3 rounded-xl bg-blue-900 hover:bg-blue-800 text-white font-semibold transition flex items-center justify-center gap-2"><Phone size={16} /> Or Call (786) 622-4963</a>
          </div>
        </div>
      </div>
    </div>
  );
};
